
import { Component, Vue } from 'vue-property-decorator'
import { BugService } from '@/services/index'

@Component({
    name: 'BugEditEemarks'
})
export default class extends Vue {
    private bugRemarks: string = ''
    private bugId: number = 0
    private callback: any = null
    private remarksVisible: boolean = false

    private show(bug: any, callback: () => void) {
        this.bugId = bug.id
        this.bugRemarks = bug.memo
        this.callback = callback
        this.remarksVisible = true
    }

    private async onUpdateRemarks() {
        this.remarksVisible = false
        const params = { id: this.bugId, memo: this.bugRemarks }
        const result = await BugService.update(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '保存成功!'
            })
            this.callback()
        } else {
            this.$message.error(result.message)
        }
    }
}
